import { useEffect, useState } from 'react';

const windowPropNameValue = 'smpCustomBettingOverlapValue';

export default function useOverlapOdds({ dataBettingLogoOverlap }: { dataBettingLogoOverlap?: boolean }) {
  const [areBettingOddsOverlapVisible, setAreBettingOddsOverlapVisible] = useState(true);

  useEffect(() => {
    if (dataBettingLogoOverlap) {
      const checkCustomValue = () => {
        const customValue = (window as any)[windowPropNameValue];
        if (customValue !== undefined && customValue !== '') {
          setAreBettingOddsOverlapVisible(Boolean(customValue));
        } else {
          // If customValue is empty or undefined, set to true (always visible)
          setAreBettingOddsOverlapVisible(true);
        }
      };

      // Initial check
      checkCustomValue();

      // Set up event listener for changes to window.smpCustomBettingOverlapValue
      const handleCustomValueChange = () => {
        checkCustomValue();
      };

      window.addEventListener(`${windowPropNameValue}Change`, handleCustomValueChange);

      return () => {
        window.removeEventListener(`${windowPropNameValue}Change`, handleCustomValueChange);
      };
    }
  }, [dataBettingLogoOverlap]);

  return { areBettingOddsOverlapVisible };
}
